/**
 * @module survey_build_ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { uiActions } from '~/behaviors/actions/ui.actions';

const defaultState = {
  haveDismissedBenchmarkTipForSurveyIds: [],
  newSurveysWithoutQuestions: [],
};

const changeSurveyBuildState = (state, action) => {
  return {
    ...state,
    ...action.payload,
  };
};

const surveyBuild = createReducer(defaultState, (builder) => {
  builder.addCase(uiActions.changeSurveyBuildUI, changeSurveyBuildState);
});

export { surveyBuild };
